import { render } from "./XyParticulars.vue?vue&type=template&id=88f77ccc&scoped=true"
import script from "./XyParticulars.vue?vue&type=script&lang=js"
export * from "./XyParticulars.vue?vue&type=script&lang=js"

import "./XyParticulars.vue?vue&type=style&index=0&id=88f77ccc&scoped=true&lang=stylus"

import exportComponent from "D:\\zhongzhi\\wuzangceping_sahngyeban\\health-WeChat-small-program-page\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88f77ccc"]])

export default __exports__